import React from "react";
import "./Our_Facilities.css";
import Common_title from "../../common-components/common_title/Common_title";
import { Col, Container, Row } from "react-bootstrap";

const Our_Facilities = () => {
  const facilities = [
    {
      img: "/assets/images/about_us/our_facilities/image-1.png",
      title: "Physical Examination (Height, Weight, BMI, Vitals)",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-2.png",
      title: "Eye Vision & Colour Vision Tests (Snellen, Ishihara)",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-3.png",
      title: "ECG, X-ray, Audiometry, Spirometry",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-4.png",
      title: "Cardiac Stress Test, 2D Echo, USG Abdomen/Pelvis",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-5.png",
      title: "Pathology Tests (NABL/NABH labs)",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-6.png",
      title: "Drug & Alcohol Testing",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-7.png",
      title: "Dental & Surgical Check-Up",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-8.png",
      title: "Mental Health & Psychological Evaluation",
    },
    {
      img: "/assets/images/about_us/our_facilities/image-9.png",
      title: "Final Fit-to-Work Certification",
    },

    {
      img: "/assets/images/about_us/our_facilities/image-10.png",
      title: "On-the-spot report delivery",
    },
  ];
  return (
    <section className="our_facilities_section">
      <div className="our_facilities_title_holder">
        <Common_title text="⚓ OUR DIAGNOSTIC FACILITIES" />
      </div>
      <p className="our_facilities_subtitle">
        At Shore Clinic, we conduct Foreign Flag Vessel / <br /> Flag State
        Medical Examinations recognized by major international maritime
        authorities.
      </p>

      <Container>
        <Row>
          {facilities.map((item, index) => (
            <Col lg={4} md={6} sm={12} className="facility_col" key={index}>
              <div className="facility_box">
                <img src={item.img} className="facility_img" alt="" />
                <div className="facility_text_holder">
                  <h4 className="facility_title">{item.title}</h4>
                  {item.desc && <p className="facility_text">{item.desc}</p>}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Our_Facilities;
